export const statusColor = (machine) => {
    if(machine.working) return 'green'
    if(!machine.active) return 'gray';
    if(machine.shift_has_data) return 'yellow';
    return 'red'
}